import { useEffect, useState } from 'react';
import { loadOrSeed, saveState } from '../lib/persist.js';

// `useState`, except it survives closing the tab.
//
// The seed is used only when there is no stored record at all. That
// distinction matters: an empty list the user created by clearing their
// history is stored as `[]` and comes back as `[]`, while a first run has
// nothing stored and gets the sample data. Without it, clearing your history
// would hand it all back on the next launch.
//
// Writes are best-effort by design — see lib/persist. A save that fails
// because storage is unavailable leaves the session working in memory, which
// is exactly how the app behaved before any of this existed.
export function usePersistentState(key, seed) {
  const [state, setState] = useState(() => loadOrSeed(key, typeof seed === 'function' ? seed() : seed));

  useEffect(() => {
    saveState(key, state);
  }, [key, state]);

  return [state, setState];
}
